import { useLoad } from "../../context/useLoadContext"
import { useError } from "../../context/useErrorContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { SignUp } from "../../Objects/SignUp/SignUp"
import { PostFormRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"
import { trackCompleteRegistrationConversion, trackMarketingEvent } from "../../analytics/tracking"

export const useSaveSignUp = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleSingUp = async (event: React.FormEvent, signUp: SignUp, onSuccess: () => void) => {
    event.preventDefault()
    enableLoad()

    try {
      const response = await PostFormRequest(API_ROUTES.ACCOUNT.CREATE, signUp.toJSON())

      if (response.success) {
        trackMarketingEvent("landing_signup_success", {
          source: "store_signup",
          plan: signUp.eaccountPlansType,
        })

        trackCompleteRegistrationConversion({
          content_name: "store_account",
          status: "created",
          plan: signUp.eaccountPlansType,
        })

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSingUp,
  }
}
